import React, { ReactNode, useEffect, useState } from 'react';
import Menu from './Menu';
import Popover from '../Popover';
import withTheme from '../../hocs/withTheme';
import { getClassNames } from '../../utils';
import './Dropdown.css';

type DropdownProps = {
    title: ReactNode;
    placement: string;
    visible?: boolean;
    overlayClassName?: string;
    children: ReactNode;
    onVisibleChange?: ((visible: boolean) => void) | undefined;
};

function Dropdown({
    title = null, children = null, placement = 'bottomLeft', visible: visibleProp = false, onVisibleChange = () => {},
    overlayClassName = '', ...rest
} : DropdownProps) {
    const [visible, setVisible] = useState(visibleProp);
    const onChange = (show) => {
        setVisible(show);
        onVisibleChange(show);
    };

    const menu = <Menu {...rest} className="dropdown">{children}</Menu>;

    useEffect(() => {
        setVisible(visibleProp);
    }, [visibleProp]);

    return (
        <button className={getClassNames('Dropdown-container', { 'Dropdown-container__opened': visible })}>
            <Popover
                placement={placement}
                content={menu}
                overlayClassName={`dropdown-inner ${overlayClassName}`}
                visible={visible}
                trigger={['click']}
                onVisibleChange={onChange}
            >
                {title}
            </Popover>
        </button>
    );
}

export default withTheme(Dropdown);
